import React from "react";
import styles from "./fields.module.css";

export interface CheckboxFieldProps {
  id?: string;
  label?: string;
  checkboxLabel?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  onBlur?: () => void;
  required?: boolean;
  disabled?: boolean;
  error?: string;
}

export const CheckboxField: React.FC<CheckboxFieldProps> = ({
  id,
  label,
  checkboxLabel,
  checked,
  onChange,
  onBlur,
  required,
  disabled,
  error,
}) => {
  const titleId = id && label ? `${id}-title` : undefined;

  // When there is no checkboxLabel, the <label> has no text — use aria-labelledby
  // so the top span becomes the accessible name for the input.
  // When checkboxLabel exists, the <label htmlFor> already names the input —
  // use aria-describedby to add the top span as extra context.
  const ariaLabelledBy = titleId && !checkboxLabel ? titleId : undefined;
  const ariaDescribedBy = titleId && checkboxLabel ? titleId : undefined;

  return (
    <div className={styles.container}>
      {label && (
        <span id={titleId} className={styles.label}>
          {label} {required && <span className={styles.required}>*</span>}
        </span>
      )}
      <label className={styles.checkboxRow} htmlFor={id}>
        <input
          id={id}
          type="checkbox"
          className={styles.checkboxInput}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          onBlur={onBlur}
          required={required}
          disabled={disabled}
          aria-labelledby={ariaLabelledBy}
          aria-describedby={ariaDescribedBy}
        />
        {checkboxLabel && (
          <span className={styles.checkboxLabel}>{checkboxLabel}</span>
        )}
      </label>
      <span
        className={styles.errorText}
        aria-live="polite"
        style={{ minHeight: "1rem" }}
      >
        {error}
      </span>
    </div>
  );
};
